<template>
  <div class="columns">
    <div class="column">

      <b-dropdown>
        <button slot="trigger" class="button is-primary">
          <span>Actions&nbsp;&nbsp;&nbsp;</span>
          <b-icon icon="menu-down"></b-icon>
        </button>

        <b-dropdown-item :disabled="isGameStopped(game) || isGamePlaying(game)" value="edit"
                         @click="triggerEditGame(game)">
          <b-icon icon="pencil"></b-icon>
          Edit game
        </b-dropdown-item>

        <b-dropdown-item v-if="isGameCloned(game)" value="declone"
                         @click="triggerDecloneGame(game)">
          <b-icon icon="checkbox-multiple-blank-outline"></b-icon>
          De-clone game
        </b-dropdown-item>

        <b-dropdown-item value="teams" @click="triggerManageTeams(game)">
          <b-icon icon="account-multiple"></b-icon>
          Manage Teams
        </b-dropdown-item>

        <b-dropdown-item value="preview" @click="triggerPreviewGame(game)" >
          <b-icon icon="map"></b-icon>
          <span v-if="isGamePlaying(game)">View Live Map</span>
          <span v-else>Preview game</span>
        </b-dropdown-item>

        <hr v-if="isGamePlaying(game) || isGameStopped(game)" class="dropdown-divider">

        <b-dropdown-item v-if="isGamePlaying(game) && !game.isLeaderDisabled" value="enable"
                         @click="triggerDisableLeaderboard(true)">
          <b-icon icon="eye-off"></b-icon>
          Disable LeaderBoard
        </b-dropdown-item>

        <b-dropdown-item v-if="isGamePlaying(game) && game.isLeaderDisabled" value="disable"
                         @click="triggerDisableLeaderboard(false)">
          <b-icon icon="eye"></b-icon>
          Enable LeaderBoard
        </b-dropdown-item>

        <b-dropdown-item v-if="isGamePlaying(game) || isGameStopped(game)" value="gameCompletion"
                         @click="triggerShowGameCompletion(game)">
          <b-icon icon="check"></b-icon>
          View Game Progress
        </b-dropdown-item>

        <b-dropdown-item v-if="isGamePlaying(game) || isGameStopped(game)" value="leaderboard"
                         @click="triggerShowLeaderboard(game)">
          <b-icon icon="trophy-variant"></b-icon>
          View Leaderboard
        </b-dropdown-item>

        <b-dropdown-item v-if="isGameStopped(game)" @click="triggerShowGameSummary(game)">
          <b-icon icon="chart-bar"></b-icon>
          View Game summary
        </b-dropdown-item>

        <hr class="dropdown-divider">

        <b-dropdown-item value="generateNewPin" @click="triggerGenerateNewPin(game)">
          <b-icon icon="refresh"></b-icon>
          Re-generate PIN
        </b-dropdown-item>

        <b-dropdown-item value="duplicate" @click="triggerShowDuplicateGame(game)">
          <b-icon icon="content-duplicate"></b-icon>
          Duplicate Game
        </b-dropdown-item>

        <b-dropdown-item :disabled="isGamePlaying(game)" value="archive" @click="triggerConfirmArchiveGame(game)">
          <b-icon icon="delete"></b-icon>
          Archive Game
        </b-dropdown-item>

      </b-dropdown>

      <b-tooltip :delay="500" label="Play">
        <b-button v-if="isGameNotActive(game)" :disabled="isGameNotSetUp(game) || isGameStopped(game)"
                  class="button is-success"
                  icon-right="play" @click="triggerConfirmStartGame(game)">
        </b-button>
      </b-tooltip>
      <b-tooltip :delay="500" label="Reset">
        <b-button v-if="isGamePlaying(game)" class="button is-warning" icon-right="rotate-left"
                  @click="triggerConfirmResetGame(game)">
        </b-button>
      </b-tooltip>
      <b-tooltip :delay="500" label="Pause">
        <b-button v-if="isGamePlaying(game)" class="button is-info" icon-right="pause"
                  @click="triggerConfirmPauseGame(game)">
        </b-button>
      </b-tooltip>
      <b-tooltip :delay="500" label="Resume">
        <b-button v-if="isGamePaused(game)" class="button is-success" icon-right="play"
                  @click="triggerConfirmResumeGame(game)">
        </b-button>
      </b-tooltip>
      <b-tooltip :delay="500" label="Stop">
        <b-button v-if="isGamePlaying(game)" class="button is-danger" icon-right="stop"
                  @click="triggerConfirmStopGame(game)">
        </b-button>
      </b-tooltip>
    </div>
  </div>
</template>

<script>
import gameHelper from '../../helpers/game-helper'

export default {
  name: 'GameManagePanel',
  props: {
    game: {
      gameStatus: '',
      questionCount: 0,
      teamCount: 0,
      playerCanAddTeams: false,
      timer: {
        hoursElapsed: 0,
      }
    }
  },
  methods: {
    isGameStopped: gameHelper.isGameStopped,
    isGamePlaying: gameHelper.isGamePlaying,
    isGamePaused: gameHelper.isGamePaused,
    isGameNotActive: gameHelper.isGameNotActive,
    isGameNotSetUp: gameHelper.isGameNotSetUp,
    isGameCloned: gameHelper.isGameCloned,

    triggerConfirmArchiveGame() {
      this.$emit('triggerConfirmArchiveGame', this.game)
    },
    triggerShowDuplicateGame() {
      this.$emit('triggerShowDuplicateGame', this.game)
    },
    triggerGenerateNewPin() {
      this.$emit('triggerGenerateNewPin', this.game)
    },
    triggerPreviewGame() {
      this.$emit('triggerPreviewGame', this.game)
    },
    triggerDecloneGame() {
      this.$emit('triggerDecloneGame', this.game)
    },
    triggerManageTeams() {
      this.$emit('triggerManageTeams', this.game)
    },
    triggerEditGame() {
      this.$emit('triggerEditGame', this.game)
    },
    triggerConfirmStartGame() {
      this.$emit('triggerConfirmStartGame', this.game)
    },
    triggerConfirmPauseGame() {
      this.$emit('triggerConfirmPauseGame', this.game)
    },
    triggerConfirmResumeGame() {
      this.$emit('triggerConfirmResumeGame', this.game)
    },
    triggerConfirmStopGame() {
      this.$emit('triggerConfirmStopGame', this.game)
    },
    triggerConfirmResetGame() {
      this.$emit('triggerConfirmResetGame', this.game)
    },
    triggerShowGameCompletion() {
      this.$emit('triggerShowGameCompletion', this.game)
    },
    triggerShowLeaderboard() {
      this.$emit('triggerShowLeaderboard', this.game)
    },
    triggerShowGameSummary() {
      this.$emit('triggerShowGameSummary', this.game)
    },
    triggerDisableLeaderboard(disabled) {
      this.$emit('triggerDisableLeaderboard', disabled, this.game)
    }
  }
}
</script>

<style scoped>

.button {
  margin: 2px;
}

.button .icon {
  padding-right: 10px;
}
</style>
